export const geoJsonFilePath = 'data/qld_lga.geo.json';
// export const hhsDataFilePath = 'data/hhs-data.json';
export const dataFilePath = 'data/water_data.json';



// WEBPACK FOOTER //
// ./src/config/index.js